module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        resourceConnected: false
    }
}